import type { AudioLanguage } from "@/backend/db/drizzle/types/jsonTypes";
import type { LocalizationRegion } from "@/utils/localizationRegion";

type RegionalVoices = {
  languages: readonly AudioLanguage[];
  voiceIds: readonly string[];
};

const BRITISH_ENGLISH_VOICE_IDS = [
  "DbwWo4rVEd5NrejHYUnm", // Jess
  "KLON7Nwan8mJxpF2R8Yw", // Frederick
];

// Listed first in the voice picker, in order; the first available voice is the region's default.
const REGIONAL_VOICES: Record<LocalizationRegion, readonly RegionalVoices[]> = {
  europe: [
    { languages: ["en", "en-medical"], voiceIds: BRITISH_ENGLISH_VOICE_IDS },
  ],
};

export const getRegionalVoiceLanguages = (
  region: LocalizationRegion
): readonly AudioLanguage[] =>
  REGIONAL_VOICES[region].flatMap(({ languages }) => languages);

export const getRegionalVoiceIds = ({
  language,
  region,
}: {
  language: AudioLanguage;
  region: LocalizationRegion | null;
}): readonly string[] =>
  region === null
    ? []
    : (REGIONAL_VOICES[region].find(({ languages }) =>
        languages.includes(language)
      )?.voiceIds ?? []);
